import { render, staticRenderFns } from "./QuotationsStatistics.vue?vue&type=template&id=567dc00e&scoped=true&"
import script from "./QuotationsStatistics.vue?vue&type=script&lang=js&"
export * from "./QuotationsStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=567dc00e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dc00e",
  null
  
)

export default component.exports